import Admin from "@system/config/admin";
import Base from "../Base";
import Api from "../APIHandler";
const API = new Api({});

class AccountAPICall extends Base {

  getAccountList = async (params = {}) => {
    let res = {};
    let param = {}
    param.data = params
    await API.post(Admin.ACCOUNT_LIST, param).then((resHer) => {
      if (resHer.data.isSuccessFull) {
        if (resHer.data.data.accounts) {
          res = resHer.data.data
        }
      }
    });
    return res
  }

  getAccountDetail = async (params) => {
    let res = {};
    let param = {}
    param.data = params
    await API.post(Admin.GET_ACCOUNT_DETAIL, param).then((resHer) => {
      if (resHer.data.isSuccessFull) {
        res = resHer.data.data;
      }
    });
    return res;
  };
  getAccountUserList = async (params) => {
    let res = {};
    let param = {}
    param.data = params
    await API.post(Admin.GET_ACCOUNT_USER_LIST, param).then((resHer) => {
      if (resHer.data.isSuccessFull) {
        res = resHer.data;
      }
    });
    return res;
  };
  exportAccountUsrList = async (params) => {
    let data = null;
    let param = {}
    param.data = params
    param.data.responseType = "blob"
    await API.post(Admin.EXPORT_ACCOUNT_USER_LIST, param).then((resHer) => {
      data = resHer.data;
    });
    return data;
  }

  updateUnsponsorAcctByUser = async (params = {}) => {
    let res = false;
    let param = {}
    param.data = params
    await API.post(Admin.UPDATE_USER_UNSPONSOR_ACCT_BY_USER, param).then((resHer) => {
      if (resHer.data.isSuccessFull) {
        res = true
      }
    });
    return res;
  };
  exportAccountList = async (params = {}) => {
    let data = null;
    let param = {}
    param.data = params
    param.data.responseType = "blob"
    await API.post(Admin.ACCOUNT_EXPORT, param).then((resHer) => {
      data = resHer.data;
    });
    return data;
  }
  emailAccouts = async (params = {}) => {
    let data = null;
    let param = {}
    param.data = params
    await API.post(Admin.EMAIL_ACCOUNT_LIST, param).then((resHer) => {
      data = resHer.data;
    });
    return data;
  }
  emailAccountUserList = async (params = {}) => {
    let data = null;
    let param = {}
    param.data = params
    await API.post(Admin.EMAIL_ACCOUNT_USER_LIST, param).then((resHer) => {
      data = resHer.data;
    });
    return data;
  }
}

export default AccountAPICall;